// extracted by mini-css-extract-plugin
export default {"server_error":"server_error_server_error__hYGqe","image":"server_error_image__0FkL2"};